import MenuManagementContainer from './MenuManagementContainer';
export default MenuManagementContainer;
